var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"d-flex justify-center align-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7,"color":"purple"}})],1):[_c('GChart',{attrs:{"type":_vm.type,"data":_vm.chartData,"options":_vm.options}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }